import { CLINICS } from "../../../../../enums/ApiPaths";
import authApi from "../../../../../utils/api/authApi";
import { getBearerToken } from "../../../../../utils/Functions";
export async function createClinic(data, refetchData, handleSnackbar, t, setIsOpen) {
  const object = parseClinic(data);

  try {
    await authApi.post(CLINICS, object, {
      headers: await getBearerToken(),
    });
    refetchData();
    handleSnackbar("ClinicCreatedSuccesfully", "success");
    closeForm(setIsOpen);
  } catch (error) {
    handleSnackbar(error?.response?.data, "error");
  }
}
function closeForm(setIsOpen) {
  setTimeout(() => {
    setIsOpen(false);
  }, 1000);
}

export function parseClinic(data) {
  return {
    clinic: {
      title: data.clinic.title,
      city: data.clinic.city,
      zipCode: data.clinic.zipCode,
      streetAddress: data.clinic.streetAddress,
      phoneNumber: data.clinic.phoneNumber,
      email: data.clinic.email,
      country: data.clinic.country,
      url: data.clinic.url,
      shortName: data.clinic.shortName,
      hidden: data.clinic.hidden

    },
    signUpDto: {
      username: data.username,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.clinic.email,
      phoneNumber: data.phoneNumber,
      password: data.password,
    },
  };
}
